import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "bnx_cookie_consent";

const defaultPrefs = { necessary: true, analytics: false, marketing: false, ts: null };

const CookieCtx = createContext(null);

export function CookieProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const save = useCallback((next) => {
    const payload = { ...defaultPrefs, ...next, ts: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(payload));
    setPrefs(payload);
  }, []);

  const openPrefs = useCallback(() => {
    setPrefs((p) => (p ? { ...p, _showBanner: true } : { ...defaultPrefs, _showBanner: true }));
  }, []);

  const hasChosen = prefs && !prefs._showBanner;

  useEffect(() => {
    // Expose global opener for footer link
    window.__bnx_open_cookie_prefs = openPrefs;
  }, [openPrefs]);

  return (
    <CookieCtx.Provider value={{ prefs: prefs || defaultPrefs, save, openPrefs, hasChosen }}>
      {children}
    </CookieCtx.Provider>
  );
}

export function useCookies() {
  const ctx = useContext(CookieCtx);
  if (!ctx) throw new Error("useCookies must be used within CookieProvider");
  return ctx;
}
